import DefinedRoleId from "components/General-UI/DefinedRoleId";
import ThreeDots from "graphics/icons/ThreeDots";
import React, { useState } from "react";
import { ADMIN_CODE } from "constants/constants";
import Spinner from "components/General-UI/Spinner";
import spaceOptions from "./Options/spaceOptions";
import permissionsOptions from "./Options/permissionsOptions";
import myOptions from "./Options/myOptions";

import PersonStateGraphics from "./PersonStateGraphics/PersonStateGraphics";
import MoreOptionsTippy from "components/HOCS/MoreOptionsTippy";
import { PERMISSIONS } from "slices/peopleSlice";
import { getPersonName } from "helpers/randomHelpers";

const PeopleItem = ({
  type,
  user_id,
  avatar,
  given_name,
  family_name,
  other_role_id,
  currentUserId,
  permissionsEffice,
  currentSpace,
  luid = null,
  customStyle = null,
  meAdmin = null,
  peopleMedia = null,
}) => {
  const [loading, setLoading] = useState(false);

  const derivedContextMenuItems = () => {
    if (user_id === currentUserId) {
      if (type === "SPACE") return [];
      return myOptions({
        permissionsEffice: permissionsEffice,
        other_role_id: other_role_id,
        user_id: user_id,
        setLoading: setLoading,
      });
    }
    switch (type) {
      case "SPACE":
        return spaceOptions({
          meAdmin: meAdmin,
          luid: luid,
          setLoading: setLoading,
          peopleMedia: peopleMedia,
        });
      case PERMISSIONS:
        return permissionsOptions({
          permissionsEffice: permissionsEffice,
          other_role_id: other_role_id,
          user_id: user_id,
          setLoading: setLoading,
        });
      default:
        return [];
    }
  };

  return (
    <div id={`PeopleItem-${user_id}`} className="people-item">
      {avatar}
      <div className={`Txt-member-name-role`}>
        <div className="name-role-container">
          <div className="Txt-member-name">
            {getPersonName(given_name, family_name)}
          </div>
          <div>
            {other_role_id === ADMIN_CODE && type !== "ANCESTOR" ? (
              <div className="Txt-member-info">
                <span>
                  <DefinedRoleId role_id={other_role_id} showMember={false} />
                </span>
              </div>
            ) : null}
            {type === "SPACE" && currentSpace ? (
              <PersonStateGraphics
                peopleMedia={peopleMedia}
                user_id={user_id}
              />
            ) : null}
          </div>
        </div>
      </div>
      {derivedContextMenuItems() && derivedContextMenuItems()[0] && (
        <MoreOptionsTippy
          options={derivedContextMenuItems()}
          placement="bottom-end"
          offset={[0, 5]}
          customStyle={customStyle}
        >
          <button
            className={`Txt-member-button ${
              loading ? "noHover position-sticky" : ""
            } ${type === "ANCESTOR" ? "Txt-option-pop" : ""}`}
          >
            {loading ? (
              <div className={`pe-none d-inline-block`}>
                <Spinner />
              </div>
            ) : (
              <div
                className={`pe-none ${
                  user_id === currentUserId ? "my-options" : ""
                } `}
              >
                <ThreeDots />
              </div>
            )}
          </button>
        </MoreOptionsTippy>
      )}
    </div>
  );
};

export default PeopleItem;
